import {
  SET_LISTING_FILTERS,
  SET_LISTING_FILTERS_IS_LOADING,
  SET_LISTING_METADATA,
  SET_LISTING_METADATA_IS_LOADING,
} from '../constants/listingMetaDataConstants';

export const metadataInitialState = {
  destinationMeta: null,
  headerDetail: null,
  listingFilters: null,
  listingSorters: null,
  noMorePackages: false,
  numFound: 0,
  pageSize: 10,
  isLoading: true,
  branch: null,
  initialFilters: null,
  initialFiltersIsLoading: false,
};

const metadataReducer = (state = metadataInitialState, action) => {
  switch (action.type) {
    case SET_LISTING_METADATA:
      return {
        ...state,
        ...(action.payload || {}),
      };
    case SET_LISTING_METADATA_IS_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    case SET_LISTING_FILTERS:
      return {
        ...state,
        initialFilters: action?.payload?.listingFilters,
      };
    case SET_LISTING_FILTERS_IS_LOADING:
      return {
        ...state,
        initialFiltersIsLoading: action.payload,
      };
    default:
      return state;
  }
};

export default metadataReducer;
